import { API } from "./api";

const pad = (n) => String(n).padStart(2, "0");

function toGoogleStamp(date) {
  return (
    date.getUTCFullYear() +
    pad(date.getUTCMonth() + 1) +
    pad(date.getUTCDate()) +
    "T" +
    pad(date.getUTCHours()) +
    pad(date.getUTCMinutes()) +
    "00Z"
  );
}

export function googleCalendarUrl(event) {
  const start = new Date(event.start);
  const end = event.end ? new Date(event.end) : new Date(start.getTime() + 3 * 3600 * 1000);
  const details = [event.description, event.ticket_url ? `Tickets: ${event.ticket_url}` : ""]
    .filter(Boolean)
    .join("\n\n");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title,
    dates: `${toGoogleStamp(start)}/${toGoogleStamp(end)}`,
    details,
    location: event.location || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function icsUrl(event) {
  return `${API}/events/${event.id}/ics`;
}

export const EVENT_TYPES = [
  { value: "friendly", label: "Friendly", color: "#CD7F32" },
  { value: "challenge", label: "League Challenge", color: "#C0C0C0" },
  { value: "cup", label: "League Cup", color: "#FFD700" },
  { value: "prerelease", label: "Prerelease", color: "#7000FF" },
  { value: "other", label: "Other", color: "#F5901F" },
];

export const GAMES = [
  "Pokémon TCG",
  "One Piece Card Game",
  "Disney Lorcana",
  "Riftbound",
  "Magic: The Gathering",
  "Yu-Gi-Oh!",
  "Warhammer",
  "Other",
];

export function typeMeta(value) {
  return EVENT_TYPES.find((t) => t.value === value) || EVENT_TYPES[4];
}

const GAME_POSTERS = {
  "Pokémon TCG":
    "https://images.unsplash.com/photo-1613771404784-3a5686aa2be3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "One Piece Card Game":
    "https://images.unsplash.com/photo-1623617010270-46e8cc26ae18?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "Magic: The Gathering":
    "https://images.unsplash.com/photo-1732944710507-feecdfb4f2c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "Yu-Gi-Oh!":
    "https://images.unsplash.com/photo-1620336655071-6b2ea4272b15?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "Disney Lorcana":
    "https://images.unsplash.com/photo-1674106890436-368ce68342f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  Riftbound:
    "https://images.unsplash.com/photo-1674106890436-368ce68342f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  Warhammer:
    "https://images.unsplash.com/photo-1735016662106-32e81bdeec9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  Other:
    "https://images.pexels.com/photos/7047507/pexels-photo-7047507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

const PRERELEASE_POSTER =
  "https://images.pexels.com/photos/7809125/pexels-photo-7809125.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export function posterFor(event) {
  if (!event) return GAME_POSTERS.Other;
  if (event.image_url) {
    return event.image_url.startsWith("/")
      ? `${process.env.REACT_APP_BACKEND_URL}${event.image_url}`
      : event.image_url;
  }
  if (event.event_type === "prerelease") return PRERELEASE_POSTER;
  return GAME_POSTERS[event.game] || GAME_POSTERS.Other;
}
